import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { FiChecklist2TemplateDescriptionComponent } from './fi-checklist2-template-description.component';
import { FiAppTextSharedModule } from '../../app-text';

@NgModule({
    imports: [CommonModule, MatCardModule, FiAppTextSharedModule, MatExpansionModule, MatIconModule],
    declarations: [FiChecklist2TemplateDescriptionComponent],
    exports: [FiChecklist2TemplateDescriptionComponent],
})
export class FiChecklist2TemplateDescriptionModule {}
